import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, tap, concatMap } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { WhatsappBot } from '@core/models/whatsapp-bot.model';
import { Pagination } from '@core/models/pagination.model';

@Injectable()
export class WhatsappBotDataService extends DefaultDataService<WhatsappBot> {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
      super('WhatsappBot', http, httpUrlGenerator, { root: '' });
  }

  getAll(): Observable<WhatsappBot[]> {
    return this.http.get<ApiResponse>('/whatsappbot').pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  add(whatsappBot?: WhatsappBot): Observable<WhatsappBot>{
    return this.http.post<ApiResponse>(`/whatsappbot`, whatsappBot).pipe(
      tap( res => this.messages$.next(res.message)),
      concatMap((entity) => this.http.get(`/whatsappbot/${entity.data.rows.id}`).pipe(
        map((row: ApiResponse) => row.data.rows)
      ))
    );
  }

  getWithQuery(pageParam: string): Observable<WhatsappBot[]>{
    return this.http.get<ApiResponse>(`/whatsappbot${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    )
  }

  getById(id: number): Observable<WhatsappBot>{
    return this.http.get<ApiResponse>(`/whatsappbot/${id}`).pipe(
      map(res => res.data.rows)
    );
  }

  getQR(id:number){
    return this.http.get<ApiResponse>(`/whatsappbot/${id}/scan`,{});
  }

  private paginationInit(res: any) {
    if(res) {
      this.pagination = res.data.paginations;
    }
  }

}
